import { Link } from "react-router-dom";

const columns = [
  {
    title: "浏览内容",
    links: [
      { label: "新闻资讯", to: "/news" },
      { label: "影视作品", to: "/works" },
      { label: "写真图集", to: "/gallery" },
      { label: "特别专题", to: "/special" },
    ],
  },
  {
    title: "关于本站",
    links: [
      { label: "网站介绍", to: "/about" },
      { label: "版权声明", to: "/about" },
      { label: "联系方式", to: "/about" },
      { label: "意见反馈", to: "/about" },
    ],
  },
  {
    title: "推荐专题",
    links: [
      { label: "镜头里的二十年", to: "/special/s001" },
      { label: "光影留白", to: "/special/s002" },
      { label: "不止于表演", to: "/special/s003" },
      { label: "港片回望", to: "/special/s004" },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-background-200 bg-secondary-100">
      <div className="w-full px-4 py-12 md:px-8 md:py-16 lg:px-12">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-5">
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-vip-crown-2-line text-lg" aria-hidden="true"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-semibold text-foreground-950">张柏芝</span>
                <span className="mt-1 text-[10px] uppercase tracking-[0.3em] text-foreground-500">
                  CECILIA CHEUNG
                </span>
              </span>
            </Link>
            <p className="mt-5 max-w-sm text-sm leading-7 text-foreground-600">
              一个专注整理张柏芝演艺动态与作品的资讯站点。我们按时间归档新闻，按角色梳理作品，
              希望每一次访问都能快速找到你关心的那一段。
            </p>
            <div className="mt-6 flex flex-wrap gap-4 text-xs text-foreground-600">
              <span className="flex items-center gap-1.5">
                <i className="ri-mail-line text-primary-600" aria-hidden="true"></i>
                hello@cecilia-archive.cn
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line text-primary-600" aria-hidden="true"></i>
                工作日 10:00 — 18:00
              </span>
            </div>
          </div>

          {columns.map((column) => (
            <div key={column.title}>
              <h4 className="text-xs font-medium uppercase tracking-[0.22em] text-foreground-500">
                {column.title}
              </h4>
              <ul className="mt-4 space-y-3">
                {column.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="text-sm text-foreground-700 transition-colors hover:text-primary-700"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-300/70 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 张柏芝明星资讯站 · 本站为非官方粉丝整理的资讯站点，内容仅供演示</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-information-line" aria-hidden="true"></i>
            站内数据为示范内容，用于展示页面效果
          </p>
        </div>
      </div>
    </footer>
  );
}